import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FormGroup, Table, Button } from 'reactstrap';
import { Search } from 'react-bootstrap-icons';
import './GerenciamentoTurmas.css'

const GerenciamentoTurmas = (props) => {

    const [listaTurmas, setListaTurmas] = useState(null);
    const [listaTurmasBackup, setListaTurmasBackup] = useState(JSON.parse(localStorage.getItem('listaTurmas')));
    let username = process.env.REACT_APP_ANJO_BACKEND_USER
    let password = process.env.REACT_APP_ANJO_BACKEND_PSW

    useEffect(() => {
        fillTurmaList();
    }, []);

    const fillTurmaList = async () => {
        const response = await axios.get("turma/" + props.deParaUnidades[props.token.usuario.departamento.id.codfilial], {
            auth: {
                username,
                password
            }
        })
        let orderedList = response.data.slice();
        orderedList.sort((a, b) => {
            return a["nomeTurma"].localeCompare(b["nomeTurma"]);
        });
        localStorage.setItem('listaTurmas', JSON.stringify(orderedList));
        setListaTurmas(orderedList);
    }

    const renderlistaTurmas = () => {
        let renderedList = [];
        for (let turma of listaTurmas) {
            renderedList.push(renderTurmaSingle(turma));
        }
        return renderedList;
    }

    const filterList = (valorReferencia) => {
        setListaTurmas(listaTurmasBackup);
        if (valorReferencia) {
            let listaTurmaMod = listaTurmasBackup.filter(turma => substringComparator(
                turma.nomeTurma.toUpperCase().replaceAll(' ', ''), valorReferencia.trim().toUpperCase()));
            setListaTurmas(listaTurmaMod);
        }
    }

    const substringComparator = (valorBase, valorReferencia) => {
        let splitReferencia = valorReferencia.split(' ');
        let values = 0;
        for (let substring of splitReferencia) {
            if (valorBase.includes(substring)) {
                values++;
            }
        };
        return values === splitReferencia.length;
    }

    const renderTurmaSingle = (turma) => {
        return (
            <div className="tabelaItem" onClick={() => props.putTurma(turma["codigoTurma"])}>
                <h8 className="tabelaComponent">
                    {turma["nomeTurma"]}
                </h8>
                <Search className="tabelaComponent" />
            </div>
        );
    }

    return (
        <>
            <h2 className="titulosPaginas">Gestão de Turmas</h2>
            <input type="text" placeholder="Buscar por Nome" className="pesquisaRapidaTurmas"
                onChange={(e) => filterList(e.target.value) } />
            <FormGroup>
                <div className="TabelaConfig">
                    <div className="TabelaGer" >
                    <div className="tabelaItem">
                           <h6 className="titulosTabelas">
                                NOME DA TURMA
                            </h6>
                            <h6 className="titulosTabelas">
                                OPÇÕES
                            </h6>
                    </div>
                        {listaTurmas === null ? (<tr> <td> none </td></tr>) : (renderlistaTurmas())}
                    </div>
                </div>
            </FormGroup>
        </>
    );
}

export default GerenciamentoTurmas;
